module.exports = {
  id: 15,
  name: 'Frog Jumps',
  categories: ['cardio', 'legs', 'strength'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Strength',
  points: 12,
  instructions:
    'Frog Jumps make you jump like a frog! Stand with your feet apart, squat down like a frog, then jump forward and land softly! This makes you strong and bouncy!',
  timedInstructions: [
    {
      time: 0,
      text: "Ready to jump like a frog? Let's get hopping!",
    },
    {
      time: 2,
      text: 'Stand with your feet apart, get ready!',
    },
    {
      time: 4,
      text: '3, 2, 1, START JUMPING!',
    },
    // SET 1 - 10 reps
    {
      time: 7,
      text: 'Squat down like a frog!',
    },
    {
      time: 9,
      text: 'Jump forward, hop hop!',
    },
    {
      time: 11,
      text: 'Land softly, bend your knees!',
    },
    {
      time: 13,
      text: 'Squat down, ready to jump!',
    },
    {
      time: 15,
      text: "Jump forward, you're a frog!",
    },
    {
      time: 17,
      text: 'Land softly, great form!',
    },
    {
      time: 19,
      text: 'Squat down, keep going!',
    },
    {
      time: 21,
      text: 'Jump forward, hop hop!',
    },
    {
      time: 23,
      text: "Land softly, you're doing great!",
    },
    {
      time: 25,
      text: 'Squat down, almost there!',
    },
    {
      time: 27,
      text: 'Jump forward, frog power!',
    },
    {
      time: 29,
      text: 'Land softly, keep it up!',
    },
    {
      time: 31,
      text: 'Squat down, last few jumps!',
    },
    {
      time: 33,
      text: "Jump forward, you're amazing!",
    },
    {
      time: 35,
      text: 'Land softly, great job!',
    },
    {
      time: 37,
      text: 'Squat down, almost done!',
    },
    {
      time: 39,
      text: 'Jump forward, frog champion!',
    },
    {
      time: 41,
      text: 'Land softly, perfect form!',
    },
    // REST PERIOD 1 - 15 seconds
    {
      time: 43,
      text: 'Amazing job! Take a good break now',
    },
    {
      time: 46,
      text: 'Breathe in and out, catch your breath',
    },
    {
      time: 49,
      text: "You just did 10 frog jumps, that's incredible!",
    },
    {
      time: 52,
      text: 'Your legs are getting so strong!',
    },
    {
      time: 55,
      text: 'Remember to land softly on your feet',
    },
    {
      time: 58,
      text: 'Keep your knees bent when you land',
    },
    {
      time: 61,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 64,
      text: "You're building amazing jumping power!",
    },
    {
      time: 67,
      text: 'Ready for round two, frog warrior!',
    },
    {
      time: 70,
      text: '3, 2, 1, KEEP JUMPING!',
    },
    // SET 2 - 10 reps
    {
      time: 73,
      text: 'Squat down like a frog!',
    },
    {
      time: 75,
      text: 'Jump forward, hop hop!',
    },
    {
      time: 77,
      text: 'Land softly, bend your knees!',
    },
    {
      time: 79,
      text: 'Squat down, ready to jump!',
    },
    {
      time: 81,
      text: "Jump forward, you're a frog!",
    },
    {
      time: 83,
      text: 'Land softly, great form!',
    },
    {
      time: 85,
      text: 'Squat down, keep going!',
    },
    {
      time: 87,
      text: 'Jump forward, hop hop!',
    },
    {
      time: 89,
      text: "Land softly, you're doing great!",
    },
    {
      time: 91,
      text: 'Squat down, almost there!',
    },
    {
      time: 93,
      text: 'Jump forward, frog power!',
    },
    {
      time: 95,
      text: 'Land softly, keep it up!',
    },
    {
      time: 97,
      text: 'Squat down, last few jumps!',
    },
    {
      time: 99,
      text: "Jump forward, you're amazing!",
    },
    {
      time: 101,
      text: 'Land softly, great job!',
    },
    {
      time: 103,
      text: 'Squat down, almost done!',
    },
    {
      time: 105,
      text: 'Jump forward, frog champion!',
    },
    {
      time: 107,
      text: 'Land softly, perfect form!',
    },
    // REST PERIOD 2 - 15 seconds
    {
      time: 109,
      text: 'Incredible work! Take another break',
    },
    {
      time: 112,
      text: 'Breathe in and out, feel your strength',
    },
    {
      time: 115,
      text: 'You just did 20 frog jumps total!',
    },
    {
      time: 118,
      text: 'Your legs are getting stronger!',
    },
    {
      time: 121,
      text: 'Remember to land softly on your feet',
    },
    {
      time: 124,
      text: 'Keep your knees bent when you land',
    },
    {
      time: 127,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 130,
      text: "You're becoming a jumping master!",
    },
    {
      time: 133,
      text: 'Ready for round three, frog champion!',
    },
    {
      time: 136,
      text: '3, 2, 1, KEEP JUMPING!',
    },
    // SET 3 - 10 reps
    {
      time: 139,
      text: 'Squat down like a frog!',
    },
    {
      time: 141,
      text: 'Jump forward, hop hop!',
    },
    {
      time: 143,
      text: 'Land softly, bend your knees!',
    },
    {
      time: 145,
      text: 'Squat down, ready to jump!',
    },
    {
      time: 147,
      text: "Jump forward, you're a frog!",
    },
    {
      time: 149,
      text: 'Land softly, great form!',
    },
    {
      time: 151,
      text: 'Squat down, keep going!',
    },
    {
      time: 153,
      text: 'Jump forward, hop hop!',
    },
    {
      time: 155,
      text: "Land softly, you're doing great!",
    },
    {
      time: 157,
      text: 'Squat down, almost there!',
    },
    {
      time: 159,
      text: 'Jump forward, frog power!',
    },
    {
      time: 161,
      text: 'Land softly, keep it up!',
    },
    {
      time: 163,
      text: 'Squat down, last few jumps!',
    },
    {
      time: 165,
      text: "Jump forward, you're amazing!",
    },
    {
      time: 167,
      text: 'Land softly, great job!',
    },
    {
      time: 169,
      text: 'Squat down, almost done!',
    },
    {
      time: 171,
      text: 'Jump forward, frog champion!',
    },
    {
      time: 173,
      text: 'Land softly, perfect form!',
    },
    // REST PERIOD 3 - 15 seconds
    {
      time: 175,
      text: 'Fantastic work! Take a final break',
    },
    {
      time: 178,
      text: 'Breathe in and out, feel your power',
    },
    {
      time: 181,
      text: 'You just did 30 frog jumps total!',
    },
    {
      time: 184,
      text: 'Your legs are incredibly strong!',
    },
    {
      time: 187,
      text: 'Remember to land softly on your feet',
    },
    {
      time: 190,
      text: 'Keep your knees bent when you land',
    },
    {
      time: 193,
      text: 'Breathe deeply and relax your muscles',
    },
    {
      time: 196,
      text: "You're a jumping superstar!",
    },
    {
      time: 199,
      text: 'Ready for the final round, frog master!',
    },
    {
      time: 202,
      text: '3, 2, 1, FINAL JUMP!',
    },
    // SET 4 - 10 reps
    {
      time: 205,
      text: 'Squat down like a frog!',
    },
    {
      time: 207,
      text: 'Jump forward, hop hop!',
    },
    {
      time: 209,
      text: 'Land softly, bend your knees!',
    },
    {
      time: 211,
      text: 'Squat down, ready to jump!',
    },
    {
      time: 213,
      text: "Jump forward, you're a frog!",
    },
    {
      time: 215,
      text: 'Land softly, great form!',
    },
    {
      time: 217,
      text: 'Squat down, keep going!',
    },
    {
      time: 219,
      text: 'Jump forward, hop hop!',
    },
    {
      time: 221,
      text: "Land softly, you're doing great!",
    },
    {
      time: 223,
      text: 'Squat down, almost there!',
    },
    {
      time: 225,
      text: 'Jump forward, frog power!',
    },
    {
      time: 227,
      text: 'Land softly, keep it up!',
    },
    {
      time: 229,
      text: 'Squat down, last few jumps!',
    },
    {
      time: 231,
      text: "Jump forward, you're amazing!",
    },
    {
      time: 233,
      text: 'Land softly, great job!',
    },
    {
      time: 235,
      text: 'Squat down, almost done!',
    },
    {
      time: 237,
      text: 'Jump forward, frog champion!',
    },
    {
      time: 239,
      text: 'Land softly, perfect form!',
    },
    {
      time: 241,
      text: 'You did it, frog master!',
    },
    {
      time: 243,
      text: 'Incredible work! You did 40 frog jumps!',
    },
    {
      time: 245,
      text: 'Your legs are incredibly strong!',
    },
    {
      time: 247,
      text: 'You are a jumping champion! Froggeriffic!',
    },
  ],
};
